import React, { useState } from 'react'
import ComplaintSubmitDetail from '../../students/complaint/ComplaintSubmitDetail'
import { alertActive, alertError, alertSuccess } from '../../../components/alert/swal';
import ModalCustom from '../../../components/modal/ModalCustom';
import StateComponents from '../../../components/state-component/StateComponents';
import { ComplaintApi } from '../../../api/complaint/complaint.api';
import { COMPLAINTS_STATUS } from '../../students/complaint/enum/complaint.enum';
import { useDispatch } from 'react-redux';
import { setLoading, unsetLoading } from '../../../store/loading/loading.slice';
import { useNavigate, useParams } from 'react-router-dom';
import { routeName } from '../../../routes/routeName';
import { useTranslation } from 'react-i18next';
// import ContainerButton from '../../../components/button/ContainerButton';

type Props = {
    view: boolean;
}

const ComplaintDetail: React.FC<Props> = ({ view }: Props) => {
    const { t } = useTranslation();
    const { id } = useParams();
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const [showModal, setShowModal] = useState<string>("");
    const [trick_key, set_trick_key] = useState<number>(0);
    const [reject_form, set_reject_form] = useState<{ remark: string }>({
        remark: ""
    })
    const handleApproved = (id_complaints: number, callback?: () => void) => {
        alertActive(t("รับเรื่องร้องเรียน"), t("ท่านต้องการรับเรื่องร้องเรียน ใช่หรือไม่"), undefined, undefined, async () => {
            dispatch(setLoading());
            await ComplaintApi.updateStatusBack(id_complaints, { complaints_result: "", complaints_status: COMPLAINTS_STATUS.RECEIVE_COMPLAINTS }).then((res) => {
                if (res.status < 300) {
                    alertSuccess(t("รับเรื่องร้องเรียน"), t("รับเรื่องร้องเรียน เรียบร้อยแล้ว"))
                    // navigate(routeName.cms.complaintSystem)
                    if (callback) {
                        callback();
                    }
                }
            }).catch((err) => {
                alertError(t("รับเรื่องร้องเรียน"), t("ปฏิเสธเรื่องร้องเรียน ไม่สำเร็จ"));
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })

        })
    }
    const handleReject = () => {
        setShowModal("REJECT")
    }
    const handleCloseModal = () => {
        setShowModal("");
        set_reject_form({ remark: "" });
        set_trick_key(0);
    }
    const handleSubmitReject = (id_complaints: number, callback?: () => void) => {
        alertActive(t("ปฏิเสธเรื่องร้องเรียน"), t("ปฏิเสธเรื่องร้องเรียนนี้ หรือไม่?"), undefined, undefined, async () => {
            dispatch(setLoading());
            await ComplaintApi.updateStatusBack(id_complaints, { complaints_result: reject_form.remark, complaints_status: COMPLAINTS_STATUS.NOT_RECEIVE_COMPLAINTS }).then((res) => {
                if (res.status < 300) {
                    handleCloseModal();
                    alertSuccess(t("ปฏิเสธเรื่องร้องเรียน"), t("ปฏิเสธเรื่องร้องเรียน เรียบร้อยแล้ว"));
                    set_trick_key(1);
                    // if (callback) {
                    //     callback()
                    // }
                    navigate(routeName.cms.complaintSystem);
                }
            }).catch((err) => {
                alertError(t("ปฏิเสธเรื่องร้องเรียน"), t("ปฏิเสธเรื่องร้องเรียน ไม่สำเร็จ"));
                console.log(err)
            }).finally(() => {
                dispatch(unsetLoading());
            })
        })
    }

    return (
        <div className='w-full'>
            <ComplaintSubmitDetail
                cms={true}
                view={view}
                handleApprove={handleApproved}
                handleReject={(_, callback) => {
                    handleReject();
                    if (trick_key === 1 && callback) {
                        callback();
                    }
                }}
            />



            {showModal !== "" && (
                <ModalCustom
                    open
                    title={t('ปฏิเสธเรื่องร้องเรียน')}
                    size="md"
                    subTitle={t('กรุณาระบุหมายเหตุ')}
                    onClose={handleCloseModal}
                    containerButton={{
                        onClose: handleCloseModal,
                        onSubmit: () => id ? handleSubmitReject(+id) : undefined
                    }}
                    component={
                        <div className='w-full'>
                            <StateComponents
                                typeProps={[
                                    {
                                        seq: 1,
                                        type: "TEXT_FIELD",
                                        gridProps: {
                                            xs: 12
                                        },
                                        fieldProps: {
                                            onChange: (e) => set_reject_form((prev) => ({ ...prev, remark: e.target.value })),
                                            multiline: true,
                                            row: 6,
                                            maxRows: 6,
                                            placeholder: t("ระบุเหตุผล"),
                                            // required: true,
                                            value: reject_form.remark,
                                            disablePaddingMultiline: true,
                                            inputHeight: 'auto'

                                        }
                                    }
                                ]}
                            />
                        </div>
                    }
                />
            )}
        </div>
    )
}

export default ComplaintDetail